var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-title items-center justify-between"},[_c('h3',{staticClass:"font28"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"font14",on:{"click":_vm.toMore}},[_vm._v("查看更多 "),_c('svg-icon',{attrs:{"icon-class":"arrow-right","color":"#AEAEB2","hoverColor":"#E2291E"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415645de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/column-title.vue
// module id = null
// module chunks = 